import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "unlocked"
const UnlockedIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M9 14.625C9.828 14.625 10.5 15.297 10.5 16.125S9.828 17.625 9 17.625 7.5 16.953 7.5 16.125 8.172 14.625 9 14.625" />
          <path
            fillRule="evenodd"
            d="M17.625 1.5C18.918 1.5 20.158 2.013 21.073 2.927 21.987 3.842 22.5 5.082 22.5 6.375H21C21 5.48 20.644 4.622 20.011 3.989S18.521 3 17.625 3C16.73 3 15.872 3.356 15.239 3.989S14.25 5.479 14.25 6.375V9.532C15.964 9.964 16.5 10.5 16.5 10.5V21C16.5 21.777 15.91 22.415 15.153 22.492L15 22.5H3C2.172 22.5 1.5 21.828 1.5 21V10.5S3 9 9 9C10.524 9 11.758 9.097 12.75 9.241V6H12.766C12.856 4.844 13.352 3.753 14.178 2.927 15.092 2.013 16.331 1.5 17.625 1.5M9 10.5C6.12 10.5 4.412 10.86 3.475 11.173Q3.192 11.27 3 11.353V21H15V11.353Q14.807 11.27 14.525 11.173C13.588 10.861 11.88 10.5 9 10.5"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default UnlockedIcon
